export const EQUIPMENTS_VOLUME_CHART_ENDPOINT = '/equipment-api/chart/v1/equipments-volume';
export const EQUIPMENT_USES_VOLUME_CHART_ENDPOINT = '/equipment-api/chart/v1/equipment-uses-volume';
export const EQUIPMENT_TIMERS_VOLUME_CHART_ENDPOINT = '/equipment-api/chart/v1/equipment-timers-volume';
export const EQUIPMENT_TIMERS_DURATION_CHART_ENDPOINT = '/equipment-api/chart/v1/equipment-timers-duration';
